import React from 'react';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';
import { CheckCircle2, XCircle } from 'lucide-react';
import AnimatedSection from '../AnimatedSection';

export default function Comparison() {
  const comparisonData = [
    { feature: 'Ingredients', us: 'Premium Natural Ayurvedic', them: 'Synthetic & Chemical-based' },
    { feature: 'Formulation', us: 'Balanced Ayurvedic Herbs', them: 'Harsh Compounds' },
    { feature: 'Long-term Benefits', us: 'Improves root cause & wellness', them: 'Temporary short-term fix' },
    { feature: 'Absorption', us: 'Fast acting & Easily absorbed', them: 'Poor absorption rate' },
    { feature: 'Certification', us: 'GMP Certified & Lab Tested', them: 'Often unverified' },
    { feature: 'Prescription', us: 'No Prescription Needed', them: 'Often requires doctor visit' },
  ];

  return (
    <section id="comparison" className="cs_primary_bg">
      <Spacing lg="120" md="80" />
      <div className="container">
        <div className="text-center">
          <AnimatedSection animation="fadeUp">
            <SectionHeading 
              title="Why Choose Ayumedix Wellness?" 
              subTitle="Ayumedix Wellness vs Other Brands" 
              variantColor="cs_white_color"
            />
          </AnimatedSection>
        </div>
        <Spacing lg="60" md="40" />
        
        <AnimatedSection animation="fadeUp" delay={0.2}>
          <div className="cs_comparison_wrapper">
            <div style={{
              background: 'rgba(255, 255, 255, 0.03)',
              borderRadius: '20px',
              border: '1px solid rgba(255,255,255,0.05)',
              margin: '0 auto',
              overflow: 'hidden'
            }}>
              {/* Desktop Header (Hidden on Mobile) */}
              <div className="row g-0 d-none d-md-flex" style={{ borderBottom: '1px solid rgba(255,255,255,0.05)', background: 'rgba(255,255,255,0.02)' }}>
                <div className="col-md-4 p-4 d-flex align-items-center">
                  <span className="cs_semibold text-white cs_fs_20">Feature</span>
                </div>
                <div className="col-md-4 p-4 text-center d-flex flex-column justify-content-center position-relative" style={{ 
                    background: 'linear-gradient(180deg, rgba(104, 224, 207, 0.15) 0%, rgba(104, 224, 207, 0.08) 100%)', 
                    borderLeft: '1px solid rgba(104, 224, 207, 0.3)', 
                    borderRight: '1px solid rgba(104, 224, 207, 0.3)', 
                    borderTop: '1px solid rgba(104, 224, 207, 0.3)',
                    borderTopLeftRadius: '15px', 
                    borderTopRightRadius: '15px',
                    boxShadow: '0 -10px 20px rgba(104, 224, 207, 0.1)'
                  }}>
                  <span className="cs_bold cs_accent_color cs_fs_22">Ayumedix Wellness</span>
                </div>
                <div className="col-md-4 p-4 text-center d-flex align-items-center justify-content-center">
                  <span className="cs_semibold cs_fs_20" style={{ color: '#ff6b6b' }}>Other Brands</span>
                </div>
              </div>

              {/* Data Rows */}
              {comparisonData.map((row, index) => (
                 <div className="row g-0 position-relative" key={index} style={{ borderBottom: index < comparisonData.length - 1 ? '1px solid rgba(255,255,255,0.05)' : 'none' }}>
                   
                   {/* Feature Name: Full width on mobile, 33% on desktop */}
                   <div className="col-12 col-md-4 p-3 p-md-4 d-flex align-items-center justify-content-center justify-content-md-start" style={{ background: 'rgba(255,255,255,0.02)' }}>
                     <h4 className="text-white mb-0 text-center text-md-start cs_fs_18">{row.feature}</h4>
                   </div>

                   {/* Ayumedix Wellness: 50% width on mobile, 33% on desktop */}
                   <div className="col-6 col-md-4 p-3 p-md-4 text-center d-flex flex-column align-items-center justify-content-center transition" style={{ 
                      background: 'rgba(104, 224, 207, 0.08)', 
                      borderLeft: '1px solid rgba(104, 224, 207, 0.3)', 
                      borderRight: '1px solid rgba(104, 224, 207, 0.3)',
                      borderBottom: index === comparisonData.length - 1 ? '1px solid rgba(104, 224, 207, 0.3)' : 'none',
                      borderBottomLeftRadius: index === comparisonData.length - 1 ? '15px' : '0',
                      borderBottomRightRadius: index === comparisonData.length - 1 ? '15px' : '0',
                      boxShadow: index === comparisonData.length - 1 ? '0 10px 20px rgba(104, 224, 207, 0.1)' : 'none',
                   }}>
                     <div className="d-md-none mb-2 cs_accent_color cs_semibold cs_fs_12 text-uppercase">Ayumedix Wellness</div>
                     <CheckCircle2 color="#68E0CF" className="mb-2 drop-shadow-sm" size={24} />
                     <span className="cs_semibold text-white cs_fs_16">{row.us}</span>
                   </div>

                   {/* Other Brands: 50% width on mobile, 33% on desktop */}
                   <div className="col-6 col-md-4 p-3 p-md-4 text-center d-flex flex-column align-items-center justify-content-center">
                     <div className="d-md-none mb-2 cs_semibold cs_fs_12 text-uppercase" style={{ color: '#ff6b6b' }}>Other Brands</div>
                     <XCircle color="#ff6b6b" className="mb-2 opacity-50" size={24} />
                     <span className="text-white cs_fs_16" style={{ opacity: 0.8 }}>{row.them}</span>
                   </div>

                 </div>
              ))}
            </div>
          </div>
        </AnimatedSection>
      </div>
      <Spacing lg="120" md="80" />
    </section>
  );
}
